<ng-container *transloco="let t">
  <nav class="featured-filters-toolbar-component">
    <span class="fixed-space-16" aria-hidden="true"></span>

    <popsy-sort-by-filter
      class="full-width"
      [loading]="loading"
      [value]="phoneFilterOptions?.sortBy"
      [compact]="true"
      (sortByChanged)="onSortByChanged($event)"></popsy-sort-by-filter>

    <span class="fixed-space-16" aria-hidden="true"></span>

    <popsy-filter-by-phone-filters
      class="full-width"
      [loading]="loading"
      [value]="phoneFilterOptions"
      [compact]="true"
      (phoneFiltersChanged)="
        onPhoneFiltersChanged($event)
      "></popsy-filter-by-phone-filters>

    <span class="fixed-space-16" aria-hidden="true"></span>
  </nav>
</ng-container>
